export const handleStoreAndLabModalTitle = (
  input: string,
  storeAndLabModal: IStoreAndLabModal,
) => {
  if (input === 'title') {
    if (storeAndLabModal?.modal_type === 'published') {
      return storeAndLabModal.store
        ? `فروشگاه ${
            storeAndLabModal?.store && storeAndLabModal?.store.title
          } فعال شد `
        : `آزمایشگاه ${
            storeAndLabModal?.lab && storeAndLabModal?.lab.title
          } فعال شد `;
    } else if (storeAndLabModal?.modal_type === 'rejected') {
      return storeAndLabModal?.store
        ? `فروشگاه ${
            storeAndLabModal?.store && storeAndLabModal?.store.title
          } تایید نشد `
        : `آزمایشگاه ${
            storeAndLabModal?.lab && storeAndLabModal?.lab.title
          } تایید نشد `;
    }
  }
  if (input === 'desc') {
    if (storeAndLabModal?.modal_type === 'published') {
      return storeAndLabModal.store
        ? 'فروشگاه شما تایید و فعال شد '
        : 'آزمایشگاه شما تایید و فعال شد ';
    } else if (storeAndLabModal?.modal_type === 'rejected') {
      return storeAndLabModal?.store
        ? `فروشگاه ${
            storeAndLabModal?.store && storeAndLabModal?.store.title
          } توسط کارشناسان مزرعه تایید نشد. می‌توانید اطلاعات فروشگاه را تکمیل و مجددا درخواست دهید.`
        : `آزمایشگاه ${
            storeAndLabModal?.lab && storeAndLabModal?.lab.title
          } توسط کارشناسان مزرعه تایید نشد. می‌توانید اطلاعات آزمایشگاه را تکمیل و مجددا درخواست دهید.`;
    }
  }
};
